<template>
    <div class="cps-main-page">
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item><i class="el-icon-s-home"></i>首页</el-breadcrumb-item>
            <el-breadcrumb-item>交易管理</el-breadcrumb-item>
            <el-breadcrumb-item>交易查询</el-breadcrumb-item>
        </el-breadcrumb>
        <el-divider></el-divider>

        <div class="page-content">
            <el-row @keyup.enter.native="loadData(1)">
                <el-input v-model="queryField.orderId" size="small" placeholder="订单id"></el-input>
                <el-input v-model="queryField.userName" size="small" placeholder="用户名"></el-input>
                <el-input v-model="queryField.serverName" size="small" placeholder="游戏区服"></el-input>
                <el-input v-model="queryField.roleName" size="small" placeholder="游戏角色"></el-input>
                <el-input v-model="queryField.saleUserName" size="small" placeholder="出售账号"></el-input>
                <el-select v-model="queryField.orderStatus" size="small" placeholder="订单状态">
                    <el-option label="订单状态" value=""/>
                    <el-option label="待支付" value="1"/>
                    <el-option label="已支付" value="2"/>
                    <el-option label="已完成" value="3"/>
                    <el-option label="已撤销" value="4"/>
                </el-select>
                <el-date-picker
                    size="small"
                    v-model="queryField.startTime"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="开始日期">
                </el-date-picker>
                <el-date-picker
                    size="small"
                    v-model="queryField.endTime"
                    value-format="yyyy-MM-dd"
                    type="date"
                    placeholder="结束日期">
                </el-date-picker>
                <el-button type="primary" size="small" @click="loadData(1)">查询</el-button>
                <el-button type="success" size="small" @click="exportExcel">导出</el-button>
            </el-row>
            <el-table class="cps-table-data"
                      :data="tableData" size="small"
                      border
                      :height="height"
                      style="width: 100%"
                      id="rebateSetTable">
                <el-table-column
                        prop="order_id"
                        label="订单id"
                        width="60">
                </el-table-column>
                <el-table-column
                        prop="goods_price"
                        label="订单金额"
                        width="80">
                    <template slot-scope="scope">
                        <el-popover
                            placement="bottom-start"
                            width="272"
                            trigger="click">
                            <el-table :data="historyPriceList" border>
                                <el-table-column width="110" property="before_price" label="修改前金额"></el-table-column>
                                <el-table-column width="160" property="update_time" label="修改时间"></el-table-column>
                            </el-table>
                            <el-button type="text" slot="reference" @click="queryPrice(scope.row.goods_id)">{{ scope.row.goods_price }}</el-button>
                        </el-popover>
                    </template>
                </el-table-column>
                <el-table-column
                        prop="goods_title"
                        label="商品名字"
                        width="110">
                </el-table-column>
                <el-table-column
                        prop="goods_type"
                        label="交易类型"
                        :formatter="goodTypeFormat"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="sale_user_name"
                        label="出售账号"
                        width="100">
                </el-table-column>
                <el-table-column
                    prop="phone"
                    label="绑定手机号"
                    width="100">
                </el-table-column>
                <el-table-column
                        prop="sale_server_name"
                        label="售卖者区服"
                        width="90">
                </el-table-column>
                <el-table-column
                        prop="wx"
                        label="卖家wx"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="qq"
                        label="卖家QQ"
                        width="90">
                </el-table-column>
                <el-table-column
                    prop="sale_token"
                    label="预留口令"
                    width="105">
                </el-table-column>
                <el-table-column
                    v-if="showViewPassword"
                    label="密码"
                    width="80">
                    <template v-slot="scope">
                        <el-popover
                            placement="bottom"
                            width="200"
                            trigger="click">
                            <div>
                              <div style="display: flex;justify-content: flex-start;height: 30px;align-items: center;">
                                <span style="width: 100px;">账号密码</span>
                                <span>{{password}}</span>
                              </div>
                              <div style="display: flex;justify-content: flex-start;height: 30px;align-items: center;">
                                <span  style="width: 100px;">道具养成锁</span>
                                <span>{{safePassword1}}</span>
                              </div>
                              <div style="display: flex;justify-content: flex-start;height: 30px;align-items: center;">
                                <span  style="width: 100px;">货币兑换锁</span>
                                <span>{{safePassword2}}</span>
                              </div>
                              <div style="display: flex;justify-content: flex-start;height: 30px;align-items: center;">
                                <span  style="width: 100px;">赠送交易锁</span>
                                <span>{{safePassword3}}</span>
                              </div>
                            </div>
                            <el-button slot="reference" v-show="scope.row.is_exits_password === 2" 
                                       type="text" size="small" @click="viewPassword(scope.row.order_id)">
                                查看
                            </el-button>
                        </el-popover>
                        
                    </template>
                </el-table-column>
                <el-table-column
                        label="查看图片"
                        width="80" >
                    <template slot-scope="scope">
                        <el-image
                                style="width: 50px; height: 50px"
                                :src="tableData[scope.$index].srcList[0]"
                                :preview-src-list="tableData[scope.$index].srcList">
                        </el-image>
                    </template>
                </el-table-column>

                <el-table-column
                        prop="user_name"
                        label="购买玩家账号"
                        width="120">
                </el-table-column>
                <el-table-column
                        prop="server_name"
                        label="区服名字"
                        width="90">
                </el-table-column>
                <el-table-column
                        prop="role_name"
                        label="角色名字"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="auth_code"
                        label="授权码"
                        width="70">
                </el-table-column>
                <el-table-column
                        prop="pay_status"
                        label="订单状态"
                        :formatter="orderStatusFormat"
                        width="80">
                </el-table-column>
                <el-table-column
                        prop="add_time"
                        label="下单时间"
                        width="140">
                </el-table-column>
                <el-table-column
                        width="280"
                        label="操作">
                    <template slot-scope="scope">
                        <el-button @click="payed(scope.row.order_id)" type="text" size="small">已支付</el-button>
                        <el-button @click="userNameFix(scope.row.order_id)" type="text" size="small">修改用户名</el-button>
                        <el-button @click="complete(scope.row.order_id)" type="text" size="small">已完成</el-button>
                        <el-button @click="orderCancel(scope.row.order_id)" type="text" size="small">撤销</el-button>
                        <el-button @click="informReceivable(scope.row.order_id)" type="text" size="small" v-if="showSendMsg && scope.row.pay_status === 3" style="margin-left: 0">通知卖家收款</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination class="cps-table-data"
               @current-change="loadData"
               background
               :page-size="15"
               :current-page="currentIndex"
               layout="total, prev, pager, next"
               :total="total">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {
    queryTransactionOrderList,
    payedOrder,
    completeOrder,
    userNameFix,
    orderCancel,
    queryHistoryPrice,
    querySalePassword,
    transactionOrderExportExcel, getPageButtons, informReceivable
} from '@/api/request';
    import crypto from "@/utils/crypto";
    import log from "echarts/src/scale/Log";

    export default {
        name: 'transactionList',
        data() {
            return {
                tableData: [],
                queryField: {
                    orderId: '',
                    userName: '',
                    serverName: '',
                    roleName: '',
                    orderStatus: '',
                    price: '',
                    startTime: '',
                    endTime: '',
                    saleUserName: '',
                },
                // srcList:[
                //     'https://qili-data.oss-cn-qingdao.aliyuncs.com/transaction/1038/1.jpeg',
                //     'https://qili-data.oss-cn-qingdao.aliyuncs.com/transaction/1038/2.jpeg',
                //
                // ],
                total: 0,
                height: window.innerHeight - 220,
                currentIndex: 1,
                loading: false,
                historyPriceList:[],
                password: '',
                safePassword1: '',
                safePassword2: '',
                safePassword3: '',
                showViewPassword: false,
                showSendMsg: false,
                countDownTime: 0,
            };
        },
        mounted() {
            this.loadData(1);
            this.getPageButtons();
        },
        methods: {
            loadData(index) {
                if (this.queryField.startTime) {
                    this.queryField.startTime += " 00:00:00";
                } else {
                    this.queryField.startTime = "";
                }

                if (this.queryField.endTime) {
                    this.queryField.endTime += " 23:59:59";
                } else {
                    this.queryField.endTime = "";
                }
                let params = {
                    pageNo: index,
                    pageSize: 15,
                    params: this.queryField,
                }
                queryTransactionOrderList(params).then(res => {
                    this.tableData = res.data.list;
                    this.total = res.data.total;
                    this.currentIndex = index;
                });
            },
            getPageButtons() {
                let path = this.$route.path.replace("/", "");
                getPageButtons(path).then((res) => {
                    if (res.data.success) {
                        let menuCodes = res.data.data;
                        this.showViewPassword = menuCodes.includes("transaction_view_password");
                        this.showSendMsg = menuCodes.includes("transaction_send_msg");
                    } else {
                        this.$message.error(res.data.error.message);
                    }
                });
            },
            payed(orderId) {
                this.$confirm('确认买家已付款?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    payedOrder(orderId).then(res => {
                        if (res.data.success) {
                            this.$message.success("操作成功")
                        } else {
                            this.$message.error(res.data.error.message);
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })
            },
            complete(orderId) {
                this.$confirm('订单已经完成, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    completeOrder(orderId).then(res => {
                        if (res.data.success) {
                            this.$message.success("操作成功")
                        } else {
                            this.$message.error(res.data.error.message);
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })
            },
            userNameFix(orderId) {
                this.$prompt('请更改后的用户名', '修改用户名', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputPattern: /^[a-zA-Z0-9_]{6,12}$/,
                    inputErrorMessage: '用户名格式不正确'
                }).then(({value}) => {
                    let param = {
                        "orderId": orderId,
                        "userName": value
                    }
                    userNameFix(param).then(res => {
                        if (res.data.success) {
                            this.$message.success("操作成功")
                        } else {
                            this.$message.error(res.data.error.message);
                        }
                    });
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '取消输入'
                    });
                });
            },
            orderCancel(orderId) {
                this.$confirm('撤销订单?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    orderCancel(orderId).then(res => {
                        if (res.data.success) {
                            this.$message.success("操作成功")
                        } else {
                            this.$message.error(res.data.error.message);
                        }
                    })
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消'
                    })
                })
            },
            informReceivable(orderId){
                if(this.countDownTime !== 0){
                    this.$message({
                        message: "发送短信还需等待：" + this.countDownTime + "秒",
                        type: 'info',
                    });
                    return;
                }
                this.countDown();
                this.$confirm("确认买家已付款？","提示",{
                    confirmButtonText: "确认",
                    cancelButtonText: "取消",
                    type: "warning"
                }).then(() => {
                    informReceivable(orderId).then(res => {
                        if(res.data.success){
                            this.$message.success("消息已发送");
                        }else {
                            this.$message.error(res.data.error.message);
                        }
                    })
                })
            },
            countDown(){
                let time = 120;
                let timer = setInterval(() => {
                    this.countDownTime = time;
                    time--;
                    if (time < 0) {
                        clearInterval(timer);
                    }
                }, 1000);
            },
            goodsDetail(goodsId) {
                let detailUrl = "https://g.7li.cn/#/trade/detail?id=" + goodsId;

            },
            queryPrice(goodsId){
                queryHistoryPrice(goodsId).then(res => {
                  this.historyPriceList = res.data.data
              })
            },
            viewPassword(orderId){
                //this.showPopover = true;
                querySalePassword(orderId).then(res => {
                  this.password = crypto.decrypt(res.data.data.password);
                  this.safePassword1 = this.decrypt(res.data.data.safePassword1);
                  this.safePassword2 = this.decrypt(res.data.data.safePassword2);
                  this.safePassword3 = this.decrypt(res.data.data.safePassword3);
                })
            },
            exportExcel(){
                if (this.queryField.startTime) {
                    this.queryField.startTime += " 00:00:00";
                } else {
                    this.queryField.startTime = "";
                }

                if (this.queryField.endTime) {
                    this.queryField.endTime += " 23:59:59";
                } else {
                    this.queryField.endTime = "";
                }
                transactionOrderExportExcel(this.queryField).then(res => {
                    this.downloadGO(res.data);
                })
            },
            downloadGO(data) {
                if (!data) {
                    return
                }
                let url = window.URL.createObjectURL(new Blob([data], {type: "application/vnd.ms-excel"}))
                let link = document.createElement('a')
                link.style.display = 'none'
                link.href = url
                link.setAttribute('download', "商品订单导出.xls")
                document.body.appendChild(link)
                link.click()
                this.loading = false;
            },
            orderStatusFormat(row, column, cellValue) {//订单状态（1：待支付 2：已支付 3：已完成 4:撤销）
                let ret = ''
                if (cellValue === 1) {
                    ret = "待支付"
                } else if (cellValue === 2) {
                    ret = "已支付"
                } else if (cellValue === 3) {
                    ret = "已完成"
                } else if (cellValue === 4) {
                    ret = "已撤销"
                }
                return ret;
            },
            goodTypeFormat(row, column, cellValue) {//1：账号 2：材料 ）
                let ret = ''
                if (cellValue === 1) {
                    ret = "账号"
                } else if (cellValue === 2) {
                    ret = "材料"
                }
                return ret;
            },
          decrypt(p) {//解码
            if (!p) {
              return '';
            }
            else {
              return crypto.decrypt(p)
            }
          },
        }
    }
</script>
<style scoped>

</style>
